var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17843 15.4872L6.92399 14.8208L6.91512 14.8109L6.906 14.8012L6.17843 15.4872ZM17.8216 15.4872L17.094 14.8012L17.0849 14.8109L17.076 14.8208L17.8216 15.4872ZM12 22L11.2544 22.6664C11.4442 22.8787 11.7153 23 12 23C12.2847 23 12.5558 22.8787 12.7456 22.6664L12 22ZM4 10H5C5 6.13401 8.13401 3 12 3V2V1C7.02944 1 3 5.02944 3 10H4ZM12 2V3C15.866 3 19 6.13401 19 10H20H21C21 5.02944 16.9706 1 12 1V2ZM6.17843 15.4872L6.906 14.8012C5.72339 13.547 5 11.8591 5 10H4H3C3 12.3891 3.93225 14.5627 5.45086 16.1733L6.17843 15.4872ZM20 10H19C19 11.8591 18.2766 13.547 17.094 14.8012L17.8216 15.4872L18.5491 16.1733C20.0678 14.5627 21 12.3891 21 10H20ZM12 22L12.7456 22.6664L18.5671 16.1537L17.8216 15.4872L17.076 14.8208L11.2544 21.3336L12 22ZM12 22L12.7456 21.3336L6.92399 14.8208L6.17843 15.4872L5.43286 16.1537L11.2544 22.6664L12 22ZM15 10H14C14 11.1046 13.1046 12 12 12V13V14C14.2091 14 16 12.2091 16 10H15ZM12 13V12C10.8954 12 10 11.1046 10 10H9H8C8 12.2091 9.79086 14 12 14V13ZM9 10H10C10 8.89543 10.8954 8 12 8V7V6C9.79086 6 8 7.79086 8 10H9ZM12 7V8C13.1046 8 14 8.89543 14 10H15H16C16 7.79086 14.2091 6 12 6V7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.72b3e8548d9bc79ffce4ed50bfd110b8.svg";
export { ForwardRef as ReactComponent };